import React, { useEffect, useRef } from "react";

type extendedWindow = Window &
  typeof globalThis & {
    Trustpilot: {
      loadFromElement: (element: Element) => void;
    };
  };

const TrustBox = () => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = useRef(null);

  useEffect(() => {
    const extendedWindow = window as extendedWindow;
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (extendedWindow.Trustpilot && ref.current !== null) {
      extendedWindow.Trustpilot.loadFromElement(ref.current);
    }
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="5419b6ffb0d04a076446a9af"
      data-businessunit-id="5a84bde5bee96e000199659e"
      data-style-height="20px"
      data-style-width="100%"
    ></div>
  );
};

export default TrustBox;
